var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('view-list',{ref:"viewList",attrs:{"control":_vm.tableControl}},[_c('template',{slot:"header"},[_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.e_config}},[_vm._v(_vm._s(_vm.$t('view.config')))])],1)],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }